import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'styles/common.css';
import './Home.css';
import Carousel from 'components/Carousel';
import NewsComponent from 'components/NewsComponent';

const HomePage = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const headerSections = [
    {
      id: 1,
      title: 'Company Overview',
      path: '/company-overview',
      content: `Genion Quantum Technologies is a high-tech enterprise driven by proprietary artificial intelligence (AI) and quantum mechanics (QM) innovation. The company is dedicated to deeply integrating advanced large language models (LLMs) and Transformer architectures into two frontier fields — life sciences and environmental sciences...`
    },
    {
      id: 2,
      title: 'Core Technological Advantages',
      path: '/technologies',
      content: `Genion Quantum Technologies has developed one of the most advanced AI-driven drug design platforms in the industry, combining Transformer-based molecular language modeling, diffusion model–based progressive generation, and a VAE (Variational Autoencoder) + Reinforcement Learning multi-objective optimization strategy...`
    },
    {
      id: 3,
      title: 'Intellectual Property',
      path: '/intellectual-property',
      content: `LLM-Transform-Based Molecular Generation and Optimization Framework. Utilizes SMILES (Simplified Molecular Input Line Entry System) strings for molecular representation, processed through a proprietary sequence-to-sequence model based on the Transformer architecture...`
    },
    {
      id: 4,
      title: 'Services',
      path: '/services',
      content: `AI-Driven Small Molecule Design: Leveraging Transformer architectures and large language models (LLMs) to accurately predict molecular activity and optimize pharmacokinetic properties, combined with quantum chemical calculations and graph network techniques for fine-grained optimization...`
    }
  ];

  return (
    <div className="home-page">
      <div className="carousel-section">
        <Carousel />
      </div>

      <NewsComponent />

      <div className="content-grid">
        <div className="content-card">
          <div className="card-icon">🧬</div>
          <h3>Advanced Drug Discovery</h3>
          <p>
            Genion Quantum Technologies is committed to advancing LLM-based incremental training,
            seamlessly integrating the latest drug data to continuously fine-tune models and enhance
            predictive performance.
          </p>
        </div>

        <div className="content-card">
          <div className="card-icon">⚛️</div>
          <h3>Quantum Mechanics Integration</h3>
          <p>
            In molecular generation and lead optimization, our platform significantly outperforms
            traditional AI models by combining quantum mechanics with molecular graph–based structure
            elucidation techniques.
          </p>
        </div>

        <div className="content-card">
          <div className="card-icon">🔬</div>
          <h3>Protein Interaction Analysis</h3>
          <p>
            Advanced peptide design and optimization platform powered by LLM architecture and
            geometry-based modeling technologies, offering powerful capabilities for peptide-based
            drug development.
          </p>
        </div>
      </div>

      <div className="features-section">
        <div className="section-header">
          <h2>Our Expertise</h2>
          <p>Comprehensive solutions across multiple domains of AI-driven research</p>
        </div>

        <div className="content-sections">
          {headerSections.map((section) => (
            <div key={section.id} className="section-card">
              <div className="card-header">
                <div className="card-number">0{section.id}</div>
                <h3
                  className="section-title"
                  onClick={() => handleNavigation(section.path)}
                >
                  {section.title}
                </h3>
              </div>
              <div className="section-content">
                <p>{section.content.substring(0, 180)}...</p>
                <button
                  className="btn btn-outline"
                  onClick={() => handleNavigation(section.path)}
                >
                  Learn More
                  <span className="btn-arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Ready to Transform Your Research?</h2>
          <p>Discover how our AI and quantum mechanics platform can accelerate your drug discovery process</p>
          <button className="btn btn-primary btn-large">
            Get Started Today
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePage;